import type { ObservationPositionProps } from "./observation-position.type";

import { useTranslation } from "react-i18next";

import EmptyData from "@/components/EmptyData";
import PositionCartesian from "@/components/PositionCartesian";
import PositionGps from "@/components/PositionGps";
import PositionPlanPositioning from "@/modules/position-plan-positioning";

export const ObservationPosition = ({
  observation,
}: ObservationPositionProps) => {
  const { plan_positioning, cartesian, gps } = observation.coordinates ?? {};
  const { t } = useTranslation();

  if (plan_positioning) {
    return (
      <PositionPlanPositioning
        // Add key to position components to make sure they re-render on observation change
        key={`observation-${observation.id}-plan-positioning`}
        defaultCoordinates={plan_positioning.coordinates ?? undefined}
        planSourceUrl={plan_positioning.source_url ?? undefined}
        toolbarOptions={{ showZoom: true }}
      />
    );
  }

  if (cartesian) {
    return (
      <PositionCartesian
        coordinates={cartesian.coordinates}
        imageSourceUrl={cartesian.source_url}
      />
    );
  }

  if (gps?.coordinates) {
    return (
      <PositionGps contextId={observation.id} coordinate={gps.coordinates} />
    );
  }

  return <EmptyData description={t("observation:noPosition")} />;
};
